import React from 'react';
import styles from './horizontal-line.module.scss';

export const HorizontalLine: React.FC = () => {
  return <div className={styles.horizontalLine} />;
};
